<template>
  <div :id="`target-${reqNo}`" class="coupon_content-item">
    <p class="txt_link-product">
      <a @click="searchAppliedDetail">{{ packItem.mypackName }}</a>
    </p>
    <span class="btn_delete" v-if="showRemoveBtn" @click="onSelectCheckBox"
      >삭제</span
    >
    <ul class="use_coupon-info">
      <li>
        <span class="txt_use-data">신청일</span>
        <span class="txt_use-desc">{{ packItem.reqDate }}</span>
      </li>
      <li>
        <span class="txt_use-data">신청번호</span>
        <span class="txt_use-desc">{{ packItem.applyNo }}</span>
      </li>
      <li v-if="purchaseType == 'recurring'">
        <span class="txt_use-data">정기구매 기간</span>
        <span class="txt_use-desc">{{ packItem.billingPeriod }}</span>
      </li>
      <li v-if="purchaseType == 'recurring'">
        <span class="txt_use-data">회차</span>
        <span class="txt_use-desc"
          ><span>{{ packItem.curSeq }}</span
          >회차 / 12회차</span
        >
      </li>
      <li>
        <span class="txt_use-data">상태</span>
        <span class="txt_use-desc state" :class="stateColor">{{
          packItem.userStatusName
        }}</span>
      </li>
    </ul>
<!--    onPaymentInstallment-->
    <mypacks-item-btn-group
      :button-states="buttonStates"
      :req-no="reqNo"
      @on-order="onOrder"
      @on-cancel-order="onCancelOrder"
      @on-reorder="onReorder"
      @on-payment-installment="onOrder"
      @item-state-change="$emit('item-state-change')"
    />
    <modal-unavailable-products
      ref="refSoldout"
      :purchase-type="purchaseType"
      :cur-seq="curSeq"
      :re-orderble="reOrderble"
      :re-cal-dose-info="reCalDoseInfo"
      :soldout-products="soldoutProducts"
      @remove-and-proceed="removeAndProceed"
      @cancel-pack="cancelPack"
    />
    <modal-alert ref="refAlert" />
    <modal-confirm ref="refConfirm" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { log } from "@/utils/common";
import { USER_STATUS_CODE } from "@/utils/constants";
import packApi from "@/apis/pack";
import orderApi from "@/apis/order";
import productHelpers from "@/utils/helpers/product";
import mypackHelpers from "@/utils/helpers/mypack";
import MypacksItemBtnGroup from "./MypacksItemBtnGroup.vue";
import ModalUnavailableProducts from "@/components/modal-popups/ModalUnavailableProducts.vue";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";

export default {
  name: "MypacksItem",
  components: {
    MypacksItemBtnGroup,
    ModalUnavailableProducts,
    ModalAlert,
    ModalConfirm,
  },
  props: {
    packItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stateColor: "",
      orderInfo: {},
      selectedCheckBox: false,
      buttonStates: {},

      // Stock
      orderlist: null,
      isSoldout: null,
      soldoutSkus: null,
      isEndOfSale: null,
      endOfSaleSkus: null,
      reOrderble: null,
      reCalDoseInfo: null,
      soldoutProducts: null,
      productsDetails: null,
    };
  },
  computed: {
    ...mapGetters({
      products: "product/products",
    }),
    purchaseType() {
      return this.packItem.purchaseType;
    },
    reqNo() {
      return this.packItem.reqNo;
    },
    curSeq() {
      return this.packItem.curSeq;
    },
    mypackName() {
      return this.packItem.mypackName;
    },
    packStatus() {
      return this.packItem.packStatus;
    },
    userStatus() {
      return this.packItem.userStatus;
    },
    orderKey() {
      return this.packItem.orderKey;
    },
    showRemoveBtn() {
      if (
        this.userStatus == USER_STATUS_CODE.CONSULTATION_SCHEDULED_VCALL || // 마이팩 채팅 상담 예정
        this.userStatus == USER_STATUS_CODE.CONSULTATION_SCHEDULED_ABC || // 마이팩 ABC 상담 예정
        this.userStatus == USER_STATUS_CODE.CONSULTATION_SCHEDULED_RECURRING || // 정기 구매 승인 예정
        this.userStatus == USER_STATUS_CODE.RECURRING_PURCHASE_APPROVED || // 정기 구매 승인
        this.userStatus == USER_STATUS_CODE.PAYMENT_FINISHED || // 상담 및 결제 완료
        this.userStatus == USER_STATUS_CODE.DIVISION_STARTED || // 마이팩 포장 시작
        this.userStatus == USER_STATUS_CODE.PAYMENT_INSTALLMENT // 1회 구매 할부 상담 완료
      ) {
        return false;
      }
      return true;
    },
    cmfKind() {
      return this.packItem.cfmKind;
    },
  },
  watch: {
    userStatus() {
      this.initState();
    },
    packItem() {
      this.selectedCheckBox = false;
    },
  },
  created() {
    this.selectedCheckBox = false;
    if (this.userStatus) {
      this.initState();
    }
  },
  methods: {
    initState() {
      switch (this.userStatus) {
        case USER_STATUS_CODE.CONSULTATION_SCHEDULED_VCALL:
        case USER_STATUS_CODE.CONSULTATION_SCHEDULED_ABC:
        case USER_STATUS_CODE.CONSULTATION_SCHEDULED_RECURRING:
          this.stateColor = "consulting_apply";
          break;
        case USER_STATUS_CODE.CONSULTATION_CANCELED:
          this.stateColor = "consulting_cancle";
          break;
        case USER_STATUS_CODE.RECURRING_PURCHASE_APPROVED:
          this.stateColor = "subdivide_confirm";
          break;
        case USER_STATUS_CODE.PRODUCT_UNAVAILABLE:
          this.stateColor = "consulting_cancle";
          break;
        case USER_STATUS_CODE.PAYMENT_FAILED:
          this.stateColor = "consulting_cancle";
          break;
        case USER_STATUS_CODE.CONSULTATION_INCOMPLETED:
          this.stateColor = "consulting_cancle";
          break;
        case USER_STATUS_CODE.PAYMENT_FINISHED:
          this.stateColor = "payment_confirm";
          break;
        case USER_STATUS_CODE.DIVISION_STARTED:
          this.stateColor = "subdivide_confirm";
          break;
        case USER_STATUS_CODE.DIVISION_FINISHED:
          this.stateColor = "subdivide_confirm";
          break;
        case USER_STATUS_CODE.PAYMENT_CANCELED:
          this.stateColor = "consulting_cancle";
          break;
        case USER_STATUS_CODE.PAYMENT_INSTALLMENT:
          this.stateColor = "payment_confirm";
          break;
      }

      const params = {
        userStatus: this.packItem.userStatus,
        purchaseType: this.packItem.purchaseType,
        curSeq: this.packItem.curSeq,
        paymentType: this.packItem.paymentType,
      };
      this.buttonStates = mypackHelpers.getButtonStatesFromUserStatus(params);
    },
    async searchAppliedDetail() {
      const orderToken = await orderApi.getOrderToken(this.reqNo, false, null);
      this.$store.commit("order/updateOrderToken", orderToken);
      this.$router.push(`/mypacks/${this.reqNo}`);
    },
    onSelectCheckBox() {
      this.$emit("item-check-state-change", {
        reqNo: this.reqNo,
      });
    },
    itemStateChange() {
      this.$emit("item-state-change");
    },
    checkSoldout(e) {
      this.$emit("check-sold-out", e);
    },
    // 즉시 결제
    async onOrder() {
      const r = await orderApi.getPreOrderInfo(this.reqNo);
      log("reqNo :::::::::::::::::", this.reqNo);
      log("r :::: ", r);
      if (r.msg) {
        await this.$refs.refAlert.openWithMessage(
          "월 주문 가능 횟수를 초과했습니다."
        );
        return;
      }

      // 주문 불가 제품이 존재하는 경우
      if (r.isSoldout || r.isEndOfSale) {
        // await this.init(r.orderlist);
        await this.checkSoldoutProducts(r);
        return;
      }

      if (r.error) {
        console.log(r);
        return;
      }
      
      // reset terms
      this.$store.commit("terms/reset");

      const amwayPayMethods = await orderApi.getAmwayPayMethods();
      this.$router.push({
        name: "order",
        params: {
          orderInfo: r,
          amwayPayMethods: amwayPayMethods,
          purchaseType: this.purchaseType,
        },
      });
    },
    async checkSoldoutProducts(r) {
      this.productsDetails = r.orderlist.order_detail_list.map((n) => ({
        item_name: n.item_name,
        item_sku: n.item_sku,
        pockets: n.dose,
        seq: n.dose_list,
      }));

      this.orderlist = r.orderlist;
      this.isSoldout = r.isSoldout;
      this.soldoutSkus = r.soldoutSkus;
      this.isEndOfSale = r.isEndOfSale;
      this.endOfSaleSkus = r.endOfSaleSkus;
      this.reOrderble = r.reOrderble;
      this.reCalDoseInfo = r.reCalDoseInfo;
      this.soldoutProducts = productHelpers.getSoldoutProducts(
        this.products,
        this.productsDetails,
        r.soldoutSkus,
        r.endOfSaleSkus
      );

      await this.$refs.refSoldout.open();
    },
    async removeAndProceed() {
      try {
        await this.$refs.refConfirm.openWithMessage(
          "단종 또는 일시품절 등의 제품을 제외하고 마이팩을 주문하시겠습니까?"
        );
        const r = await orderApi.removeSoldOut(
          "D",
          [...this.soldoutSkus, ...this.endOfSaleSkus],
          this.reqNo
        );
        await this.$refs.refSoldout.onDispose();
        await this.onOrder();
      } catch (e) {
        console.log(e);
      }
    },
    async cancelPack() {
      if (this.purchaseType == "single") {
        try {
          await this.$refs.refConfirm.openWithMessage(
            "단종 또는 일시품절 등의 제품으로 인해 마이팩 구매를 취소하시겠습니까?"
          );
          const r = await packApi.cancelConsultationApplied(this.reqNo);
          if (r) {
            await this.$refs.refAlert.openWithMessage(
              "마이팩이 취소되었습니다."
            );
            await this.$refs.refSoldout.onDispose();
            await this.$router.push("/");
          }
        } catch (e) {}
      } else if (this.purchaseType == "recurring") {
        if (this.isEndOfSale) {
          try {
            await this.$refs.refConfirm.openWithMessage(
              "정기 구매 제품 중 단종 제품이 포함되어 있어, 전체 주문이 취소 처리 됩니다. 정기구매를 취소하시겠습니까?"
            );
            // 정기 구매 취소
            const r = await packApi.cancelConsultationApplied(this.reqNo);
            if (r) {
              await this.$refs.refAlert.openWithMessage(
                "마이팩 정기구매가 취소되었습니다."
              );
              await this.$refs.refSoldout.onDispose();
              await this.$router.push("/");
            }
          } catch (e) {}
        } else if (this.isSoldout) {
          try {
            await this.$refs.refConfirm.openWithMessage(
              "정기 구매 제품 중 일시품절 제품이 포함되어 있어, 이번 회차에 한해 취소 처리 됩니다. 이번 회차 주문을 취소하시겠습니까?"
            );
            // 정기 구매 승인 후 TNA
            const r = await packApi.cancelPackRecurringThisMonth(this.reqNo);
            if (r) {
              await this.$refs.refAlert.openWithMessage(
                `이번 회차의 주문이 취소되었습니다.<span class="desc">* 간편 상담은 완료 되었으므로, 재고가 있는 경우 마이팩 관리에서 '재고 확인 및 결제' 버튼을 통해 즉시결제 가능합니다.</span>`
              );
              await this.$refs.refSoldout.onDispose();
              await this.$router.push("/");
            }
          } catch (e) {}
        }
      }
    },
    onReorder() {
      this.$emit("on-reorder", {
        reqNo: this.reqNo,
        mypackName: this.mypackName,
        packStatus: this.packStatus,
      });
    },
    async onCancelOrder() {
      const r = await packApi.getApplianceDetail(this.reqNo);
      if (r.error) {
        return;
      }
      this.$emit("on-cancel-order", {
        orderInfo: r.order_info[0],
        orderKey: this.orderKey,
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/mypacks/main/partial/MypacksItem.vue